import { CommonModule } from '@angular/common';
import { Component, ElementRef, HostListener, Input, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute, Params } from '@angular/router';
import { ModalGalleryImagenesVideosComponent } from '../../components/modal-gallery-imagenes-videos/modal-gallery-imagenes-videos.component';

@Component({
  selector: 'app-carrousel-facultades-simple',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './carrousel-facultades-simple.component.html',
  styleUrl: './carrousel-facultades-simple.component.scss'
})
export class CarrouselFacultadesSimpleComponent implements OnInit {
  @ViewChild('carouselWrapper') carouselWrapper!: ElementRef;
  @Input() cards: any[] = [];
  @Input() cant: number = 4;
  @Input() data: any;
  isDesktop: boolean = true;
  currentIndex: number = 0;
  componentId = 'carousel-' + Math.random().toString(36).substring(7);
  carouselTransform: string = 'translateX(0)';
  language: String = '';
  originalCards: any[] = [];
  isTransitioning: boolean = true;
  inMotion: boolean = false;

  constructor(public dialog: MatDialog, public route: ActivatedRoute, private sanitizer: DomSanitizer) {
    this.route.params.forEach((params: Params) => {
      this.language = params['language'];
    });
  }

  ngOnInit(): void {
    this.checkScreenSize();
    this.originalCards = this.cards.map((item, index) => {
      const processedItem = { ...item, position: index };
      if (item.type === 'Video (YouTube)' && item.videoUrl) {
        const videoId = this.getVideoId(item.videoUrl);
        processedItem.videoId = videoId;
        processedItem.thumbnailUrl = `https://img.youtube.com/vi/${videoId}/hqdefault.jpg`;
        processedItem.safeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(`https://www.youtube.com/embed/${videoId}`);
      }
      return processedItem;
    });

    this.setupInfiniteCarousel();
  }

  setupInfiniteCarousel(): void {
    if (!this.originalCards.length) return;

    const cloneCount = this.cant;

    const startClones = this.originalCards.slice(-cloneCount);
    const endClones = this.originalCards.slice(0, cloneCount);

    this.cards = [...startClones, ...this.originalCards, ...endClones];
    this.currentIndex = cloneCount; 

    if (this.isMobile) {
      setTimeout(() => this.centerMobileScroll(false), 100);
    } else {
      this.updateCarouselPosition();
    }
  }



  centerMobileScroll(smooth: boolean = true): void {
    if (!this.carouselWrapper) return;
    const container = this.carouselWrapper.nativeElement;
    
    // Obtenemos la celda real renderizada
    const firstCell = container.querySelector('.carousel-cell') as HTMLElement;
    if (!firstCell) return;
    
    // Ancho real en píxeles de (1 card + gap de 10px)
    const cardWidthWithGap = firstCell.offsetWidth + 10; 

    container.style.scrollBehavior = smooth ? 'smooth' : 'auto';
    
    // Al scrollear exactamente (cant * cardWidthWithGap), saltamos los clones iniciales
    // y la primera card del grupo real queda pegada al inicio del padding interior (centrada)
    container.scrollLeft = this.cant * cardWidthWithGap; 
  }

  onMobileScroll(event: Event): void {
    if (!this.isMobile || !this.carouselWrapper) return;

    const container = this.carouselWrapper.nativeElement;
    const scrollLeft = container.scrollLeft;

    const firstCell = container.querySelector('.carousel-cell') as HTMLElement;
    if (!firstCell) return;

    const cardWidthWithGap = firstCell.offsetWidth + 10;
    const totalReales = this.originalCards.length;

    const startPos = this.cant * cardWidthWithGap;
    const endPos = startPos + (totalReales * cardWidthWithGap);

    // Reset infinito hacia adelante
    if (scrollLeft >= endPos - 10) {
      container.style.scrollBehavior = 'auto';
      container.scrollLeft = startPos;
    }

    // Reset infinito hacia atrás
    if (scrollLeft <= 5) {
      container.style.scrollBehavior = 'auto';
      container.scrollLeft = endPos - cardWidthWithGap;
    }
  }
  private getVideoId(url: string): string {
    const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*/;
    const match = url.match(regExp);
    return (match && match[2].length === 11) ? match[2] : ''; 
  }

  goCarrers() {
    let url = this.data?.link;
    if (url) {
      window.open(url, '_blank', 'noopener,noreferrer');
    }
  }

  checkScreenSize() {
    const width = window.innerWidth;

    if (width > 1024) {
      this.isDesktop = true;
      this.cant = 4; 
    } else if (width > 738) {
      this.isDesktop = true; 
      this.cant = 2; 
    } else {
      this.isDesktop = false;
      this.cant = 2; 
    }

    // SOLO actualizamos posición de transform si NO es móvil
    if (!this.isMobile) {
      this.updateCarouselPosition();
    }
  }


  moveLeft(): void {
    if (this.inMotion) return;
    this.inMotion = true;
    this.currentIndex--;
    this.isTransitioning = true;
    this.updateCarouselPosition();
  }

  moveRight(): void {
    if (this.inMotion) return;
    this.inMotion = true;
    this.currentIndex++;
    this.isTransitioning = true;
    this.updateCarouselPosition();
  }

  onTransitionEnd(): void {
    const totalReales = this.originalCards.length;

    if (this.currentIndex >= totalReales + this.cant) {
      this.isTransitioning = false;
      this.currentIndex = this.cant;
      this.updateCarouselPosition();
    }

    if (this.currentIndex < this.cant) {
      this.isTransitioning = false;
      this.currentIndex = totalReales + this.cant - 1;
      this.updateCarouselPosition();
    }

    this.inMotion = false;
  }

  updateCarouselPosition(): void {
    const cardWidth = 100 / this.cant;
    const offset = this.currentIndex * cardWidth;
    this.carouselTransform = `translateX(-${offset}%)`;
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    const prevCant = this.cant;
    this.checkScreenSize();
    if (prevCant !== this.cant) {
      this.setupInfiniteCarousel();
    }
  }

  openModal(position: number): void {
    this.dialog.open(ModalGalleryImagenesVideosComponent, {
      width: '95vw',
      maxHeight: '90vh',
      maxWidth: '1200px',
      panelClass: 'full-screen-modal',
      data: { titulo: '', gallery: this.originalCards, position: position }
    });
  }

  get isMobile(): boolean {
    return window.innerWidth <= 738; 
  }
}